import { DefaultService } from '@/services/DefaultService';

export default class CategoriaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(categoria) {
        return this._http.post(`${this._env}/vendas/categoria`, categoria, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(situacao, page = 0, limit = 50, order = 'asc', sort = 'descricao', ...param) {
        return this._http.get(encodeURI(`${this._env}/vendas/categoria/list.json?page=${page}&limit=${limit}&order=${order}&situacao=${situacao}&sort=${sort}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/vendas/categoria/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(situacao = 1, ...param) {
        return this._http.get(encodeURI(`${this._env}/vendas/categoria/getcombo.json?param=${param}&?situacao=${situacao}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(categoria) {
        return this._http.post(`${this._env}/vendas/categoria/updatesituacao`, categoria, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}